import React, { useEffect } from "react";
import {
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  FormHelperText,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import useWhatsApps from '../../hooks/useWhatsApps';

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '100%',
  },
}));

const WhatsAppSelect = ({ value, onChange, error, helperText, mode = 'filter', allowNone = true, showOrphanOption = false }) => {
  const classes = useStyles();
  const { loading, whatsApps } = useWhatsApps();

  useEffect(() => {
    if (mode === 'select' && !allowNone && !value && whatsApps.length === 1 && !loading) {
      onChange(whatsApps[0].id);
    }
  }, [whatsApps, loading, value, onChange, mode, allowNone]);
  
  const showAllOption = mode === 'filter' && whatsApps.length > 1;
  
  const shouldShrink = Boolean(value) || (mode === 'select' && !allowNone && whatsApps.length === 1);
  
  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      error={error}
    >
      <InputLabel 
        id="whatsapp-select-label"
        shrink={shouldShrink ? true : undefined}
      >
        Conexión de WhatsApp
      </InputLabel>
      <Select
        labelId="whatsapp-select-label"
        id="whatsapp-select"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        label="Conexión de WhatsApp"
        disabled={loading}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left"
          },
          getContentAnchorEl: null
        }}
      >
        {showAllOption && (
          <MenuItem value="">
            <em>Todas</em>
          </MenuItem>
        )}
        {mode === 'select' && allowNone && (
          <MenuItem value="">
            <em>Ninguna</em>
          </MenuItem>
        )}
        {mode === 'select' && !allowNone && !value && (
          <MenuItem value="" disabled>
            <em>Seleccione una conexión</em>
          </MenuItem>
        )}
        {showOrphanOption && (
          <MenuItem value="-1">
            <Typography color="error">⚠️ Sin Conexión</Typography>
          </MenuItem>
        )}
        {whatsApps.map((whatsapp) => (
          <MenuItem key={whatsapp.id} value={whatsapp.id}>
            {whatsapp.name}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default WhatsAppSelect;